import React from 'react';
import PropTypes from 'prop-types';
import {
  Rectangle,
  Image,
  Typography,
  Shadow,
  Cushion,
  FlexContainer,
  Grid,
} from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';
import ClubLink from '../../club-link';
import AppInterceptedLink from '../../app-intercepted-link';
import { getForcedViewParams } from './utils';
import AssignmentBadge from './product-card-assignment-badge';

const ProductCard = ({
  id,
  name,
  image,
  amountSummary,
  variantCount,
  outOfStock,
  forceView,
  assignment,
}) => {
  const { imagePreset, breakpoint } = getForcedViewParams(forceView);

  const productContent = () => (
    <Shadow>
      <Rectangle radius="rounded" fill="white" style={{ overflow: 'hidden', height: '100%' }}>
        <Grid rows="100fr auto">
          <FlexContainer
            flexDirection="row-reverse"
            alignItems="center"
            style={{ height: '100%', width: '100%' }}
            responsive={[{ minWidth: breakpoint, props: { flexDirection: 'column' } }]}
          >
            <Cushion
              component="div"
              right="small"
              responsive={[{ minWidth: breakpoint, props: { right: '0' } }]}
            >
              <Rectangle
                radius="rounded"
                responsive={[{ minWidth: breakpoint, props: { radius: 'roundedTop' } }]}
                component="div"
                style={{ overflow: 'hidden', lineHeight: 0 }}
              >
                <Image src={image} alt={name} shimmerOnLoad preset={imagePreset} />
              </Rectangle>
            </Cushion>
            <FlexContainer flexDirection="column" style={{ flex: 1, width: '100%' }}>
              <Cushion
                top="medium"
                left="medium"
                right="small"
                style={{ flex: '1', whiteSpace: 'pre-line' }}
                component="div"
              >
                <Typography color="black" preset="subtitle--large" component="div">
                  {name}
                </Typography>
              </Cushion>
              <Cushion vertical="medium" horizontal="medium" style={{ whiteSpace: 'pre-line' }}>
                {outOfStock === false ? (
                  <Typography color="primary" preset="subtitle--small" component="div">
                    {variantCount === 1 ? (
                      amountSummary
                    ) : (
                      <Trans i18nKey="shop:options_available" values={{ variantCount }} />
                    )}
                  </Typography>
                ) : (
                  <Typography color="primary" preset="subtitle--small" component="div">
                    <Trans i18nKey="common:out_of_stock">Out of stock</Trans>
                  </Typography>
                )}
              </Cushion>
            </FlexContainer>
          </FlexContainer>
          <AssignmentBadge assignment={assignment} outOfStock={outOfStock} />
        </Grid>
      </Rectangle>
    </Shadow>
  );

  if (!outOfStock) {
    return (
      <ClubLink route="shop.product" params={{ id, _name: name }}>
        <AppInterceptedLink className="product-card">{productContent()}</AppInterceptedLink>
      </ClubLink>
    );
  }

  return productContent();
};

ProductCard.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  amountSummary: PropTypes.string,
  outOfStock: PropTypes.bool,
  variantCount: PropTypes.number.isRequired,
  forceView: PropTypes.oneOf([null, 'landscape', 'portrait']),
  assignment: PropTypes.shape(),
};

ProductCard.defaultProps = {
  amountSummary: null,
  forceView: null,
  outOfStock: false,
  assignment: null,
};

export default ProductCard;
